import { inject, Injectable } from '@angular/core';
import { nanoid } from 'nanoid';
import { ToastOptions, ToastService } from '../toast.service';
import { ToastItem } from '../toast-item';
import { StatusKind } from '@shared/ui/status/status';
import { OverlayStackService } from '@shared/ui/kit/overlay-stack/overlay-stack.service';
import { DEFAULT_PLACEMENT, OverlayStackItemKind } from '@shared/ui/kit/overlay-stack/overlay-stack-item';

@Injectable()
export class BrowserToastService extends ToastService {
  private readonly overlayStack: OverlayStackService = inject(OverlayStackService);

  success(options: ToastOptions): string {
    return this.show(options, 'success');
  }

  warning(options: ToastOptions): string {
    return this.show(options, 'warning');
  }

  error(options: ToastOptions): string {
    return this.show(options, 'error');
  }

  info(options: ToastOptions): string {
    return this.show(options, 'info');
  }

  dismiss(toastId: string): void {
    this.overlayStack.remove(toastId);
  }

  private show(options: ToastOptions, kind: StatusKind): string {
    const toastId = nanoid();

    const toast: ToastItem = {
      id: toastId,
      kind,
      title: options.title,
      message: options.message,
      link: options.link,
      isClosable: options.isClosable ?? true
    };

    this.overlayStack.show({
      id: toastId,
      kind: OverlayStackItemKind.toast,
      placement: options.position ?? DEFAULT_PLACEMENT.toast,
      durationMs: options.isPermanent ? undefined : (options.duration ?? (kind === 'error' ? 7000 : 4000)),
      toast
    });

    return toastId;
  }
}
